/**
 * Collections V8 PRO — filter sidebar / mobile drawer toggle (HD variant).
 * Cloned from component-clv8p-filters.js; own .clv8p-* namespace.
 *
 * Desktop (>=1024px): the sidebar is a static sticky column; this script is
 * inert there apart from Escape handling. Below 1024px the sidebar becomes a
 * fixed off-canvas drawer toggled by .clv8p-filter-toggle; an overlay and the
 * close/apply buttons dismiss it. Filtering itself is handled live by the
 * shared <facet-filters-form> machinery — no apply step is needed.
 *
 * Uses delegated document listeners so it survives the Section Rendering
 * API re-renders (only .js-filter innerHTML and .active-facets are swapped;
 * the sidebar and toggle elements persist).
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'clv8p-filters-open';

  function isOpen() {
    return document.body.classList.contains(OPEN_CLASS);
  }

  function setOpen(open) {
    document.body.classList.toggle(OPEN_CLASS, open);
    document.body.style.overflow = open && window.innerWidth < 1024 ? 'hidden' : '';
    var toggle = document.querySelector('.clv8p-filter-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var sidebar = document.querySelector('.clv8p-sidebar');
      var firstInput = sidebar && sidebar.querySelector('summary, input, button');
      if (firstInput && window.innerWidth < 1024) firstInput.focus();
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.clv8p-filter-toggle')) {
      setOpen(!isOpen());
      return;
    }
    if (event.target.closest('[data-clv8p-filters-close]')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) setOpen(false);
  });

  // Leaving the mobile breakpoint while the drawer is open would otherwise
  // strand the body scroll lock.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024 && isOpen()) setOpen(false);
  });
})();
